import { Typography } from "@material-ui/core";
import { get } from "lodash";

interface IFinancialInformationField {
  source: string;
  financialData: IFinancialInformation;
  label?: string;
  emptyText?: string;
}

const FinancialInformationField = ({
  source,
  financialData,
}: IFinancialInformationField) => {
  const data = get(financialData, source);

  return (
    <Typography variant="body2">
      {data === undefined || data === null
        ? `-`
        : `$ ${(data / 100).toLocaleString()}`}
    </Typography>
  );
};

export default FinancialInformationField;
